import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/monitoring/ga4';

/**
 * SPA 라우트 변경 시 GA4 page_view 이벤트를 자동 전송한다.
 * BrowserRouter 내부에서 한 번만 호출해야 한다.
 */
export function usePageTracking(): void {
  const location = useLocation();
  const prevPathRef = useRef<string>('');

  useEffect(() => {
    const path = location.pathname + location.search;
    if (path === prevPathRef.current) return;
    prevPathRef.current = path;
    trackPageView(path);
  }, [location]);
}
